<div class="form-group">
  <div *ngFor="let item of names; let i = index" class="form-check form-check-inline">
    <input
      class="form-check-input"
      type="radio"
      name="radioGroup"
      [id]="'radio-' + i"
      [value]="item.id"  
      [checked]="selectedValue === item.id"
      (change)="onSelectionChange(item.id)"   
    />
    <label class="form-check-label" [for]="'radio-' + i">
      {{ displayName(item) }}
    </label>
  </div>
</div>
